import React from "react";
import PropTypes from "prop-types";
import { getTailwindUtilityAsNumber, debugLog } from "../../utils/index";
import { imageProps } from "../propTypes"; // Adjust the path as necessary

let maxHeight = 400;

const Image = ({
  image,
  forceWidth = null,
  forceHeight = null,
  className = "",
  style = {},
  imageNextToText = false,
  fullWidth = false,
}) => {
  let width = 0;
  let height = 0;
  let url = null;

  if (fullWidth) {
    maxHeight = 1000; // maxHeight not used when fullWidth is true, but this is a fallback
  }
  if (image && image.width && image.height) {
    width =
      forceWidth ||
      Math.min(
        image.width,
        fullWidth
          ? getTailwindUtilityAsNumber("width", "image-max")
          : getTailwindUtilityAsNumber("width", "image")
      );
    height =
      forceHeight ||
      (fullWidth
        ? (width * 4 * image.height) / image.width
        : (width * image.height) / image.width);
    if (width > image.height && fullWidth) {
      width = getTailwindUtilityAsNumber("width", "image-max");
      height = (width * image.height) / image.width;
      imageNextToText = true; // container is wider than it is tall, so we want to contain the image
    }
    if (height > maxHeight && !fullWidth) {
      height = maxHeight;
      width = (height * image.width) / image.height;
    }
    if (Object.prototype.hasOwnProperty.call(image, "url")) {
      url = image.url;
      if (url.includes("uploads/")) {
        const splitURL = image.url.split("uploads/");
        const rootPath = `${splitURL[0]}uploads/`;
        const endPath = splitURL[1];
        const noParams = endPath.split("?")[0];
        // This strips out any params of the image (most likely with a datestamp for cache-busting or with size parameters), pulling the raw image from the cloudfront distibrution.
        // Note, if you change this logic, update the .env.example documentation for ENV CRAFT_ASSET_BASE_URL_OVERRIDE
        if (process.env.GATSBY_ASSET_BASE_URL_OVERRIDE) {
          url = `${process.env.GATSBY_ASSET_BASE_URL_OVERRIDE}${noParams}`;
        } else {
          url = `${rootPath}${noParams}`;
        }
      }
      if (url.includes("videouploads/")) {
        const splitURL = image.url.split("videouploads/");
        const rootPath = `${splitURL[0]}videouploads/`;
        const endPath = splitURL[1];
        const noParams = endPath.split("?")[0];
        // This strips out any params of the image (most likely with a datestamp for cache-busting or with size parameters), pulling the raw image from the cloudfront distibrution.
        // Note, if you change this logic, update the .env.example documentation for ENV CRAFT_ASSET_BASE_URL_OVERRIDE
        if (process.env.GATSBY_ASSET_BASE_URL_OVERRIDE) {
          url = `${process.env.GATSBY_ASSET_BASE_URL_OVERRIDE}${noParams}`;
        } else {
          url = `${rootPath}${noParams}`;
        }
      }
    }
  } else {
    debugLog(`
      Invalid image received: 
      ${JSON.stringify(image?.url || image)} 
      width: ${JSON.stringify(image?.width)} 
      height: ${JSON.stringify(image?.height)}}
    `);
  }

  const conditionalStyles = imageNextToText
    ? {
        ...style,
        size: "contain",
      }
    : {
        ...style,
        width,
        height,
      };

  return (
    <div>
      {image && url ? (
        <div className={className} style={conditionalStyles}>
          <img
            src={url}
            alt={image.alt || "DCI DigiGuide figure"}
            width={width}
            height={height}
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
      ) : (
        <div>|No Image|</div>
      )}
    </div>
  );
};

Image.propTypes = {
  image: imageProps.isRequired, // Using imageProps from propTypes.js
  forceWidth: PropTypes.number,
  forceHeight: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object, // Style is an object; you can define specific shapes if needed
  imageNextToText: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default Image;
